/**
 * @module
 *
 * @import {Engine} from '@acng/frontend-stargazer';
 * @import {LivecamSession} from 'acng/livecam/model/session.js';
 * @import {UserData} from 'acng/user/model/user-data.js';
 */

import {errorTemplate, rootScope} from '@acng/frontend-stargazer';
import {GlobalWatchGroup} from '@acng/frontend-relativity';
import {body, createDiv, removeChildNodes, setHtml} from '@acng/frontend-bounty';
import {ctxAuthUser} from 'acng/userPool/context/auth-user.js';
import {ctxLocale} from 'acng/locale/model/locale.js';
import {throttle} from '@acng/frontend-bounty/timing/throttle.js';
import {hookFeature} from '../config/feature.js';
import {connectLocation, disconnectLocation} from './location.js';
import {createFrontendFeature} from '../model/feature.js';
import {ctxLivecamSession} from '../../livecam/context/session.js';
import {ACNG} from '../../app.js';
import {inject, isInjectable} from './ng.js';
import {make} from './env.js';
import {purgeAll} from '../purge.js';

setHtml(errorTemplate, '<strong class="drf-notfound">🚧 ${message} 🚧</strong>');

createFrontendFeature('lv6');
const app = make(ACNG);
DEBUG: window.acng = app;
Object.setPrototypeOf(rootScope, app);

/**
 * @param {angular.IRootScopeService} $rootScope
 * @param {angular.ICompileService} $compile
 */
export const runBootstrap = ($rootScope, $compile) => {
  /**
   * @type {angular.IScope}
   */
  let $scope;

  /**
   * @type {Engine}
   */
  let engine;

  let eventDuringLivecamSession = false;

  /**
   * @param {[LivecamSession | null, UserData | null, unknown]} values
   * @param {[LivecamSession | null | undefined, UserData | null | undefined, unknown]} previous
   */
  const bootstrap = async ([livecamSession, authUserData], [prevLivecamSession]) => {
    if (livecamSession != prevLivecamSession) {
      if (livecamSession || !eventDuringLivecamSession) {
        return;
      }

      eventDuringLivecamSession = false;
    } else if (livecamSession) {
      if (!prevLivecamSession) {
        eventDuringLivecamSession = true;
      }

      return;
    }

    DEBUG: console.debug('Remove global template.');
    removeChildNodes(div);
    engine?.disconnect();
    $scope?.$destroy();
    DEBUG: console.debug('Disconnect AngularJS $location.');
    disconnectLocation();
    purgeAll();
    $scope = $rootScope.$new();
    engine = await hookFeature.render('body');
    DEBUG: console.debug('Render global template.', engine);

    if (authUserData) {
      if (isInjectable('Actionslider')) {
        inject('Actionslider').display(authUserData);
      }
    }

    $compile(engine.toElement(div))($scope);
    DEBUG: console.debug('Connect AngularJS $location.');
    connectLocation();
    $scope.$digest();
  };

  const div = createDiv();
  body.prepend(div);

  GlobalWatchGroup(ctxLivecamSession, ctxAuthUser, ctxLocale)(throttle(bootstrap, 10, false));
};
